import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {RegionForm} from 'src/pages/Modules/Project/shared/RegionForm';
import {RegionDocumentTitle} from 'src/pages/Modules/Project/shared/regionHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

export const RegionCreatePage = () => {
  useSetDocumentTitle(RegionDocumentTitle);

  return (
    <ContentWrapper>
      <RegionForm mode="create" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ProjectRegionsCreate(),
  element: <RegionCreatePage />,
  module: ModuleEnum.Projects,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});
